import React from 'react';

import { BaseInput } from 'src/components/BaseInput';

import { TBaseTextareaProps } from './BaseTextarea.types';

export const BaseTextarea: React.FC<TBaseTextareaProps> = ({ ...baseInputProps }) => {
  return <BaseInput type="textarea" {...baseInputProps} showValidationIcon={false} />;
};
